import { render } from "./MoneyTransferModal.vue?vue&type=template&id=6d8fe383&scoped=true&ts=true"
import script from "./MoneyTransferModal.vue?vue&type=script&lang=ts"
export * from "./MoneyTransferModal.vue?vue&type=script&lang=ts"

import "./MoneyTransferModal.vue?vue&type=style&index=0&id=6d8fe383&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8fe383"]])

export default __exports__